import {Component, HostBinding} from '@angular/core';

const componentBaseName = 'mainarea';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-mainarea',
  templateUrl: './mainarea.component.html',
  styleUrls: ['./mainarea.component.scss'],
})
export class MainareaComponent {
  @HostBinding('class') classNames = defaultClassNames;

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-base/components/mainarea/mainarea.component.ts